var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"showmodel anim",on:{"click":function($event){return _vm.closeShow()}}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"showmodel-div"},[_c('img',{attrs:{"src":require("../../../../assets/img/test/assiant_2wml.png")}}),_c('img',{staticClass:"two-wm",attrs:{"src":require("../../../../assets/img/test/assiant_2wm111.jpg")}})])
}]

export { render, staticRenderFns }